import { render, staticRenderFns } from "./groupedCard.vue?vue&type=template&id=f60c9826&scoped=true&"
import script from "./groupedCard.vue?vue&type=script&lang=js&"
export * from "./groupedCard.vue?vue&type=script&lang=js&"
import style0 from "./groupedCard.vue?vue&type=style&index=0&id=f60c9826&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f60c9826",
  null
  
)

export default component.exports